<template>
  <v-container>
    <v-dialog v-model="showTable" persistent width="70%">
      <v-card class="px-6">
        <v-card-text>
          <v-row id="infos">
            <v-col class="text-center py-8" cols="12">
              <h1>Associar lotes a cronograma</h1>
            </v-col>
            <v-col class="text-right px-5" cols="6">
              <p class="mb-0"><b>Lotes selecionados:</b></p>
              <p class="mr-15 pr-9">{{ length }}</p>
            </v-col>
            <v-col class="text-left px-5" cols="6">
              <p>
                <b>Valor calculado (R$):</b><br />{{ vl_total | formatPrice }}
              </p>
            </v-col>

            <v-tabs class="elevation-0" v-model="abaPadrao">
              <v-tab
                href="#tab-cronograma-exis"
                :disabled="listCrono.length == 0"
                >Cronograma existente</v-tab
              >
              <v-tab href="#tab-novo-cronograma">Novo cronograma</v-tab>

              <v-tab-item value="tab-cronograma-exis">
                <v-divider></v-divider>
                <v-col class="radio-style px-0 py-6" cols="12">
                  <v-data-table
                    :headers="headers"
                    :items="listCrono"
                    hide-default-footer
                    dense
                  >
                    <template v-slot:item="props">
                      <tr style="height: 50px">
                        <td class="text-center px-2 py-0">
                          <tr>
                            <td class="pa-0 px-1" style="border:none">
                              <v-radio-group
                                class="mt-2 mb-0"
                                v-model="selected"
                              >
                                <v-radio :value="props.item"></v-radio>
                              </v-radio-group>
                            </td>
                            <td class="pa-0" style="border:none">
                              {{ props.item.dt_faturamento | formatDate }}
                            </td>
                          </tr>
                        </td>

                        <td class="text-center px-2 py-0">
                          {{ props.item.owner_username }}
                        </td>
                        <td class="text-center px-2 py-0">
                          {{ props.item.prest_nome }}
                        </td>
                        <td class="text-center px-2 py-0">
                          {{ props.item.oper_nome }}
                        </td>
                        <td class="text-center px-2 py-0">
                          {{ props.item.vl_prev_faturamento | formatPrice }}
                        </td>
                        <td class="text-center px-2 py-0">
                          {{ props.item.vl_importado | formatPrice }}
                        </td>
                        <td class="text-center px-2 py-0">
                          {{ props.item.qtd_lotes }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-tab-item>

              <v-tab-item value="tab-novo-cronograma">
                <v-divider></v-divider>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-col cols="auto" sm="11">
                    <CronogramaForm
                      :close="(formData) => 
                      saveCronoEAssociaLote({
                        upload_user_id: userData.Id,
                        lotes: lotesIds,
                        ...formData 
                      })"
                      :dadoscronograma="dadoscronograma"
                      :disableFields="true"
                      :isAssociar="true"
                    />
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-tab-item>
            </v-tabs>

            <v-col
              class="px-6"
              cols="2"
              v-show="abaPadrao == 'tab-cronograma-exis'"
            >
              <v-btn
                outlined
                width="100%"
                height="30px"
                small
                color="primary"
                depressed
                class="px-5"
                @click="wip();"
                >Cancelar</v-btn
              >
            </v-col>
            <v-col
              class="pa-0"
              cols="8"
              v-show="abaPadrao == 'tab-cronograma-exis'"
            ></v-col>
            <v-col
              class="px-6"
              cols="2"
              v-show="abaPadrao == 'tab-cronograma-exis'"
            >
              <v-btn
                width="100%"
                height="30px"
                small
                color="primary"
                depressed
                class="px-5"
                :disabled="Object.keys(this.selected).length === 0"
                @click="associarLotes()"
                >Salvar</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
const cronoInit = {
          grupo_economico: null,
          dt_faturamento: null,
          dt_prev_vencimento: null,
          id: null,
          prestador_id: null,
          owner_id: null,
          operadora_ans_id: null,
          vl_prev_faturamento: null,
          qtd_dias_notificacao: null,
          recorrencia: null,
          ocorrencia: null,
          login_prestador: '',
          tipo_guia: null,
        }
  import { mapState } from 'vuex';
  import { VMoney } from 'v-money';
  import CronogramaForm from '@/components/faturamento/cronograma_form/cronogramaForm';
  export default {
    components: {
      CronogramaForm,
    },
    data() {
      return {
        showTable: false,
        selected: {},
        lotesIds: [],
        abaPadrao: null,
        dadoscronograma: {},
        headers: [
          {
            text: 'Faturamento',
            align: 'faturamento',
            value: 'faturamento',
            sortable: false,
          },
          { text: 'Responsável', value: 'responsavel', sortable: false },
          { text: 'Prestador', value: 'prestador', sortable: false },
          { text: 'Operadora', value: 'operadora', sortable: false },
          { text: 'Vl. previsto', value: 'vl_previsto', sortable: false },
          { text: 'Vl. importado', value: 'vl_importado', sortable: false },
          { text: 'Lotes', value: 'lotes', sortable: false },
        ],
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false,
        },
      };
    },
    computed: {
      ...mapState({
        userData: (state) => state.userData.userData,
        grupoEconomico: (state) => state.permissions.grupoEconomico,
      }),
    },
    filters: {
      formatPrice(value) {
        let val = (value / 1).toFixed(2).replace('.', ',');
        return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      },
      formatDate(date) {
        return date.split(' ')[0];
      },
    },
    watch: {
      showTable(val) {
        this.dadoscronograma = { ...cronoInit }
        if (val) {
          this.lotesIds = this.selectedLotes.map((lote) => ({
            lote_id: lote.id,
            dt_alteracao: lote.dt_alteracao,
          }));
          let { prestador_id, operadora_ans_id, tipo_guia_id, login_prestador } = this.selectedGrupo

          this.dadoscronograma.grupo_economico = this.grupoEconomico;
          this.dadoscronograma.prestador_id = prestador_id;
          this.dadoscronograma.operadora_ans_id = operadora_ans_id;
          this.dadoscronograma.tipo_guia = tipo_guia_id;
          this.dadoscronograma.login_prestador = login_prestador;

          // VERIFICAR PERMISSÂO
          var userFatPermissoes = this.userData.Permissao.faturamento;
          var userIsGestor = userFatPermissoes.some((perm) => perm == 'gestor');

          this.dadoscronograma.owner_id = userIsGestor
            ? null
            : String(this.userData.Id);
        } else {
          this.dadoscronograma = { ...cronoInit }
        }
      },
      tableInfo(val) {
        this.showTable = val;
        this.dadoscronograma = {
          grupo_economico: null,
          dt_faturamento: null,
          dt_prev_vencimento: null,
          id: null,
          prestador_id: null,
          owner_id: null,
          operadora_ans_id: null,
          vl_prev_faturamento: null,
          qtd_dias_notificacao: null,
          recorrencia: null,
          ocorrencia: null,
          login_prestador: '',
          tipo_guia_id: null,
        };
      },
      listCrono(val) {
        if (val.length == 0) this.abaPadrao = 'tab-novo-cronograma';
        else this.abaPadrao = 'tab-cronograma-exis';
        this.lotesIds = this.selectedLotes.map((item) => ({
          lote_id: item.id,
          dt_alteracao: item.dt_alteracao,
        }));
      },
    },
    methods: {
      formatDate(date) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      },
      wip() {
        this.selected = {};
        this.showClose(false); 
      },
      associarLotes() {
        let {id,remessa_id, prestador_id, operadora_ans_id, tipo_guia_id  } = this.selected
        if (this.abaPadrao == 'tab-cronograma-exis') {
          let objQuery = Object.assign({
            cronograma_id: id,
            remessa_id,
            operadora_ans_id,
            prestador_id,
            tipo_guia_id,
            lotes: this.lotesIds,
            selecionar_todos: this.selecionarTodos,
            upload_user_id: this.userData.Id,
          });

          let paramModal = {
            type: 'info',
            title: 'Confirmar ação',
            message: 'Você poderá editar novamente quando necessário',
            callback: () => this.associarLoteCronoExistente(objQuery),
            btConfirm: { name: 'Salvar', show: true },
            btCancel: { name: 'Cancelar', show: true },
          };
          this.$store.commit('confirmMessage/showConfirmMessage', paramModal);
        }
      },
    },
    props: {
      listCrono: Array,
      getListCronos: Function,
      selectedGrupo: Object,
      selectedLotes: Array,
      tableInfo: Boolean,
      showClose: Function,
      vl_total: Number,
      associarLoteCronoExistente: Function,
      saveCronoEAssociaLote: Function,
      length: Number,
      selecionarTodos: Boolean
    },
    directives: {
      money: VMoney,
    },
  };
</script>
<style scoped>
  .v-data-table {
    max-height: 35vh;
    overflow-y: scroll;
    overflow-x: hidden;
    overscroll-behavior: contain;
  }
  div#tab-novo-cronograma {
    max-height: 50vh;
    overflow-y: scroll;
    overflow-x: hidden;
    overscroll-behavior: contain;
  }
  .radio-style
  .v-input__slot {
    margin-bottom: 0px;
  }
</style>
